import { User as BaseUser } from './user';

export class AuthUser extends BaseUser {
  public clientIds: number[] = [];
}

// Re-export types so others can do _User.ReadableProps
export namespace AuthUser {
  export import ReadableProps = BaseUser.ReadableProps;
  export import RestTypes = BaseUser.RestTypes;
}
